const WishlistIcon = ({
  className = ""
}: {
  className?: string;
}) => <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' className={className} data-sentry-element="svg" data-sentry-component="WishlistIcon" data-sentry-source-file="WishlistIcon.tsx">
    <path d='M19 9.0625V21.5L11.5 17.5625L4 21.5L4 5.6875C4 4.77344 4.82031 4 5.875 4H15.5385' stroke='currentColor' strokeWidth='1.5' data-sentry-element="path" data-sentry-source-file="WishlistIcon.tsx" />
    <circle cx='18.5' cy='5.5' r='3.75' stroke='currentColor' strokeWidth='1.5' data-sentry-element="circle" data-sentry-source-file="WishlistIcon.tsx" />
  </svg>;
export default WishlistIcon;